import Base from "./Base";
import useCallDataApi from "../hooks/data";
import {useEffect, useState} from "react";
import {getSubdomain} from "../utils/Utils";
import Loading from "../components/Loading";
import ProductCard from "../components/ProductCard";
import {Grid, TextField, Select, MenuItem, FormControl, InputLabel, Typography, Stack, Box} from "@mui/material";

const Products = () => {
    const {getData: fetchProducts} = useCallDataApi('sp-extra-item');
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");
    const [sortOrder, setSortOrder] = useState(""); // Default sorting order

    // Debounce effect for search
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchQuery(searchQuery);
        }, 500);

        return () => clearTimeout(handler); // Cleanup on component unmount or query change
    }, [searchQuery]);

    // Fetch data when debounced search query or sort order changes
    useEffect(() => {
        setLoading(true);
        const fetchFilteredProducts = async () => {
            const queryParams = new URLSearchParams({
                subdomain: getSubdomain(),
                search: debouncedSearchQuery,
                ordering: sortOrder,
            }).toString();
            try {
                const result = await fetchProducts(`get_for_business?${queryParams}`);
                setProducts(result);
            } finally {
                setLoading(false);
            }
        };
        fetchFilteredProducts();
    }, [debouncedSearchQuery, sortOrder]);

    return (
        <Base>
            <div className="services-container">
                <div className="white-card" style={{marginBottom: '20px'}}>
                    <Stack spacing={2}>
                        <Typography variant='headline6' gutterBottom>Termékek</Typography>
                        <Typography variant='caption'>Keresés:</Typography>
                        {/* Search Bar */}
                        <TextField
                            fullWidth
                            margin="normal"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            variant='standard'
                        />
                        <Typography variant='caption'>Rendezés:</Typography>

                        {/* Sort Dropdown */}
                        <FormControl fullWidth margin="normal" variant='standard'>
                            <Select
                                value={sortOrder}
                                onChange={(e) => setSortOrder(e.target.value)}
                            >
                                <MenuItem value="">-</MenuItem>
                                <MenuItem value="price">Ár szerint növekvő</MenuItem>
                                <MenuItem value="-price">Ár szerint csökkenő</MenuItem>
                                <MenuItem value="created_at">Legújabb</MenuItem>
                                <MenuItem value="-created_at">Legrégebbi</MenuItem>
                            </Select>
                        </FormControl>
                    </Stack>
                </div>

                {/* Product Grid */}
                <Grid container spacing={2}>
                    {products?.map((p) => (
                        <Grid item xs={12} md={6} key={p?.id}>
                            <ProductCard product={p} />
                        </Grid>
                    ))}
                    {products?.length === 0 && <Box sx={{height: '30px', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <Typography variant='caption'>Nem találtunk ilyen terméket! 😔</Typography>
                    </Box>}
                </Grid>
            </div>
            <Loading isLoading={loading} />
        </Base>
    );
};

export default Products;
